import LogService from "../../CommonSdk/LogService";

import * as AnalyticsService from "../../RainbowSdk/AnalyticsService";

const LOG_TAG = "ACTION:ANALYTICS";

export const retrieveGroupsOfMetrics = () => dispatch => {
    LogService.info(LOG_TAG, "retrieveGroupsOfMetrics", "Get the metrics groups");

    return AnalyticsService.getMappingMetricsGroups()
        .then(json => {
            return Promise.resolve(json);
        })
        .catch(errorPayload => {
            LogService.error(LOG_TAG, "retrieveGroupsOfMetrics", "can't retrieve the groups of metrics");
            return Promise.reject(errorPayload);
        });
};

export const getAnalytics = (applicationid, period, fromDay, toDay, options) => dispatch => {
    LogService.info(LOG_TAG, "getAnalytics", "Get analytics");

    return AnalyticsService.getApplicationMetrics(applicationid, fromDay, toDay, period, options)
        .then(json => {
            LogService.debug(LOG_TAG, "getAnalytics", "successfully received");
            return Promise.resolve(json);
        })
        .catch(errorPayload => {
            return Promise.reject(errorPayload);
        });
};

export const getThresholds = (applicationId) => dispatch => {
    LogService.info(LOG_TAG, "getThresholds appID=" + applicationId);

    return AnalyticsService.getApplicationThresholds(applicationId)
        .then(jsonThreshold => {
            return Promise.resolve(jsonThreshold);
        })
        .catch(errorPayload => {
            LogService.error(LOG_TAG, "getThresholds error", errorPayload);
            return Promise.reject(errorPayload);
        })
};

export const addThreshold = (applicationId, groupName, notification, value) => dispatch => {
    LogService.trace(LOG_TAG, "addThresholds");

    return AnalyticsService.createApplicationThreshold(applicationId, groupName, notification, value)
        .then(data => {
            return Promise.resolve();
        })
        .catch(errorPayload => {
            LogService.error(LOG_TAG, "addThreshold error", errorPayload);
            return Promise.reject(errorPayload);
        })
};

export const updateThreshold = (applicationId, groupName, thresholdType, notification, value) => dispatch => {
    LogService.info(LOG_TAG, "updateThreshold");

    return AnalyticsService.updateApplicationThreshold(applicationId, groupName, thresholdType, notification, value)
        .then(data => {
            return Promise.resolve();
        })
        .catch(errorPayload => {
            LogService.error(LOG_TAG, "updateThreshold error", errorPayload);
            return Promise.reject(errorPayload);
        });
}

export const deleteThreshold = (applicationId, groupName, thresholdType) => dispatch => {
    LogService.info(LOG_TAG, "deleteThreshold", "Delete Threshold");

    return AnalyticsService.deleteApplicationThreshold(applicationId, groupName, thresholdType)
        .then(data => {
            return Promise.resolve();
        })
        .catch(errorPayload => {
            LogService.error(LOG_TAG, "deleteThreshold error", errorPayload);
            return Promise.reject(errorPayload);
        })
}

